import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Cpa {
  static getById (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`carta_de_porte_automotor?r=` +
      `{"clave": {"numero": "${id}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static getConsultaById (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_carta_de_porte_automotor?r=` +
      `{"clave":{"numero": "${id}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static getCpaPorCodigoDeCupo (codigoCupo) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["d:fecha_de_alta"]'
    const promise = axios.get(`/consulta_carta_de_porte_automotor_por_codigo?r={"clave": {"codigo_cupo":"${codigoCupo}"}, ${orden}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data)
  }

  static updateVariedadCpa (cerealVariedad, numero) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/carta_de_porte_automotor`,
      `{"valores": {"cereal_variedad": "${cerealVariedad}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  static anularIngreso (cpa) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`carta_de_porte_automotor_ingreso?r=` +
      `{"clave":{"numero": "${cpa}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static busquedaCpa (numero = null, ctg = null,
    camion = null, acoplado = null) {
    const axios = getAxiosInstance()
    const promise = axios.get(`carta_de_porte_automotor_busqueda?r=` +
    `{"clave": {"numero": ${numero}, "ctg": ${ctg},` +
    `"camion": "${camion}", "acoplado": "${acoplado}"},` +
      `"limite":1, "orden": ["d:fecha_de_alta"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static estadoCpa (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_mensaje_estado_cpa?r=` +
      `{"clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static detalleCompletoCpa (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_informacion_descarga?r=` +
      `{"clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  // Este metodo actualiza una CPE que fue rechazada por mal confeccionada.
  static actualizarDesdePresunta (numero, camion, acoplado) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/carta_de_porte_automotor_ingreso`,
      `{"valores": {"camion": "${camion}", "acoplado": "${acoplado}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }

  // Esta funcion deja estado_ctg en Postergado para volver a validarse
  static desactivarEstadoCtg (numero) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/carta_de_porte_automotor`,
      `{"valores": {"estado_ctg": "P", "observaciones_ctg": null, "validacion_ctg": null,` +
      `"fecha_de_egreso_playa": null, "fecha_de_abandono": null, "motivo_abandono": null,` +
      `"usuario_abandono": null }, "clave": {"numero": ${numero}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }

  // Esta funcion cambia estado_ctg para luego desactivarse
  static cambiarEstadoCtg (numero, estado) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/carta_de_porte_automotor`,
      `{"valores": {"estado_ctg": "${estado}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }

  // Metodo utilizado en Calado para validar solo en Afip
  static validarCpeEnAfip (cpeSucursal, cpeSecuencia, titularCpe) {
    const axios = getAxiosInstance()
    const promise = axios.get(`validarcpe?r=` +
      `{"parametros": {"estado": "V", "cpe_sucursal": ${cpeSucursal}, "cpe_secuencia": ${cpeSecuencia}, "titular_de_cp": ${titularCpe}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }
}

export default Cpa
